// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDragNDropTableBuilder-DataContainer_cls1__vEkew","cls2":"VeloDragNDropTableBuilder-DataContainer_cls2__NECCR VeloDragNDropTableBuilder-DataContainer_cls1__vEkew"};